import React from "react";

import Projects from "./Projects";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Background } from "../public/styled";


export default function layout(props: any) {
     // Set doc title
     document.title = `Dashboard | Web360`

    return (
        <Background css="min-width: 1200px">
            <Sidebar page={'Dashboard'}/* tokenStatus={props.tokenStatus}  *//>
            <Projects />
        </Background>
    )
}
